import { baseApiURL, apiKeys, user } from "../../Utilities/Utility";
import axios from "axios";


export function getInspNumber(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        mode: "cors",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
        /* params: { userId: userId },*/
    };
    return fetch(baseApiURL + "/PDIR/InspectionNumberWorkflow", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
};


//UpdateISIRFinalClosure
export function SaveInspData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, inspData) {
    const options = {
        method: "post",
        mode: "cors",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
            //"Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(inspData),

    };
    return fetch(baseApiURL + "/PDIR/PostInspectionDetails", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function AddLineItemDetails(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, payload) {
    const options = {
        method: "post",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
        body: JSON.stringify(payload),
    };
    return fetch(baseApiURL + "/PDIR/PostLineItemInspectionDetails", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}



export function UpdateLineItemDetails(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, payload) {
    const options = {
        method: "post",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
        body: JSON.stringify(payload),
    };
    return fetch(baseApiURL + "/PDIR/PostLineItemInspectionDetails", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetInspection(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
        baseApiURL + "/PDIR/GetInspections",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetApprovedInspection(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
        baseApiURL + "/PDIR/GetApprovedInspections",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetCommodity(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
        baseApiURL + "/PDIR/GetCommodity",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetProductMaster(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
        baseApiURL + "/PDIR/GetProductMaster",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetFinalDecision(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
        baseApiURL + "/PDIR/GetFinalDecision",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetInspectionLineItems(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    InspectionNumberId
  ) {
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId: userId,
      },
    };
  
    return fetch(
      `${baseApiURL}/PDIR/GetInspectionLineItems?InspectionNumberId=${InspectionNumberId}`,
      options
    )
      .then((response) => response.json())
      .then((data) => data.result)
      .catch((error) => {
        console.log("Error:", error);
      });
  }

  export function GetSuppliers(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    value
  ) {
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId: userId,
      },
    };
  
    return fetch(
      `${baseApiURL}/PDIR/GetSuppliers?value=${value}`,
      options
    )
      .then((res) => res.json())
      .then((data) => data.result.objResult)
      .catch((err) => console.log("Error:", err));
  }


  export function GetSpiridonNo(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    value
  ) {
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId: userId,
      },
    };
  
    return fetch(
      `${baseApiURL}/PDIR/GetParts?value=${value}`,
      options
    )
      .then((res) => res.json())
      .then((data) => data.result.objResult)
      .catch((err) => console.log("Error:", err));
  }


  export function AddAttachmentDetails(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, formData) {
    const options = {
        method: "post",
        mode: "cors",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,

        },
        body: formData,
    };
    return fetch(baseApiURL + "/PDIR/UploadInspectionAttachments", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

// // export function GetUploadAttachmentsDetail(siteToken,
//     azureToken,
//     userId,
//     userEmail,
//     gid,
//     roleName,
//     roleId, InspectionNumberId,uploadedSpace) {
//     const options = {
//         headers: {
//             Authorization: "Bearer " + siteToken,
//             AzureToken: azureToken,
//             UserEmail: userEmail,
//             RoleName: roleName,
//             Gid: gid,
//             Roleid: roleId,
//             userId: userId,
//         },
//         /* params: { userId: userId, complaintNumber: complaintNumber },*/
//         params: { InspectionNumberId: InspectionNumberId},
//         ...(uploadedSpace !== null && { UploadedSpace: uploadedSpace })
//     };
//     return axios.get(
//         baseApiURL + "/PDIR/GetInspectionAttachments",
//         options
//     )
//         .then((response) => {
//             return response.data.result;
//         })
//         .catch((error) => {
//             console.log("Error : ", error);
//         });
// }

export function GetUploadAttachmentsDetail(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    InspectionNumberId,
    uploadedSpace
) {

    let query = `?InspectionNumberId=${InspectionNumberId}`;

    if (uploadedSpace !== null && uploadedSpace !== undefined) {
        query += `&UploadedSpace=${uploadedSpace}`;
    }

    const options = {
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        }
    };

    return axios
        .get(baseApiURL + "/PDIR/GetInspectionAttachments" + query, options)
        .then((response) => response.data.result)
        .catch((error) => console.log("Error:", error));
}




export function deleteLineItem(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    lineItemId
  ) {
    const options = {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId: userId,
      },
      body: null // backend only needs query param
    };
  
    return fetch(`${baseApiURL}/PDIR/DeleteLineItem?LineItemId=${lineItemId}`, options)
      .then((response) => response.json())
      .then((data) => data.result)
      .catch((error) => {
        console.log("Error : ", error);
      });
  }


  export function acknowledgeReport(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    inspectionNumberId,
    acknowledgeId

  ) {
    const options = {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId:userId,
      },
      body: null // backend only needs query param
    };
  
    return fetch(`${baseApiURL}/PDIR/AcknowledgeReport?InspectionNumberId=${inspectionNumberId}&AcknowledgeId=${acknowledgeId}`, options)
      .then((response) => response.json())
      .then((data) => data.result)
      .catch((error) => {
        console.log("Error : ", error);
      });
  }


  export function rejectReport(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    inspectionNumberId,
    rejectedId,
    remarks
  ) {
    const options = {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: "Bearer " + siteToken,
        AzureToken: azureToken,
        UserEmail: userEmail,
        RoleName: roleName,
        Gid: gid,
        Roleid: roleId,
        userId:userId,
      },
    };
  
    return fetch(
      `${baseApiURL}/PDIR/RejectReport?InspectionNumberId=${inspectionNumberId}&RejectedId=${rejectedId}&Remarks=${encodeURIComponent(
        remarks
      )}`,
      options
    )
      .then((response) => response.json())
      .then((data) => data.result)
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  



  export function deleteInspectionAttachments(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    attachmentId
) {

    const options = {
        method: "put",
        headers: {
            Accept: "application/json, text/plain, */*",
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        }
    };

    return fetch(
        `${baseApiURL}/PDIR/DeleteInspectionAttachments?attachmentId=${attachmentId}`,
        options
    )
        .then((response) => response.json())
        .then((data) => data.result)
        .catch((error) => console.log("Error:", error));
}



// get filedata based on commodity

export function GetFileDetailsBasedOnCommoidty(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    comId
) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
          `${baseApiURL}/PDIR/GetPDIRDocumentList?commodityId=${comId}`, 
           options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

// new commo dev
export function SaveOrUpdatePdirDocumentList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, docData) {
    const options = {
        method: "post",
        mode: "cors",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
            //"Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(docData),

    };
    return fetch(baseApiURL + "/PDIR/SaveOrUpdatePdirDocumentList", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetSelectedPdirDocumentList(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    inspectionNumberId
) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
          `${baseApiURL}/PDIR/GetSelectedPdirDocumentList?inspectionNumberId=${inspectionNumberId}`, 
           options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

  
  
  
////uploadfile data
export function uploadCommodityFileData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId, fileData) {

    const options = {
        method: "post",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,

        },
        processData: false,
        mimeType: "multipart/form-data",  //question need tobe ask
        contentType: false,
        body: fileData,
    };
    return fetch(baseApiURL + "/PDIR/UploadExtraAttachments", options)

        .then((response) => response.json())
        .then((data) => {
            console.log("data", data.result)
            return data.result;

        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetuploadedAttachments(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    inspId,
    uploadedSpace
) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };
    return fetch(
          `${baseApiURL}/PDIR/GetInspectionAttachments?InspectionNumberId=${inspId}&UploadedSpace=${uploadedSpace}`, 
           options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

//ReviewerRejectedReport--reviwer
export function rejectReviewerReport(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    inspectionNumberId,
    reviwerId,
    reviewerRemark
) {
    const options = {
        method: "PUT",
        headers: {
            Accept: "application/json, text/plain, */*",
            Authorization: "Bearer " + siteToken,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId: userId,
        },
    };

    return fetch(
        `${baseApiURL}/PDIR/ReviewerRejectedReport?InspectionNumberId=${inspectionNumberId}&ReviewerId=${reviwerId}&remarks=${reviewerRemark}`,
        options
    )
        .then((response) => response.json())
        .then((data) => data.result)
        .catch((error) => {
            console.log("Error : ", error);
        });
}


